import { BaseQueryFn, EndpointBuilder, FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { APP_ENDPOINTS } from 'app/endpoints';
import { NestedProduct } from 'features/nested-product/types/dtos';

type QueryParms = {
    placeId: string;
    productId: string;
};

export default (builder: EndpointBuilder<BaseQueryFn, string, string>) =>
    builder.query<NestedProduct[], QueryParms>({
        async queryFn(_args, _queryApi, _extraOptions, fetchWithBQ) {
            const result = await fetchWithBQ(
                `${APP_ENDPOINTS.PRODUCT}/${_args.productId}/place/${_args.placeId}/nested-products`,
            );

            if (result.error) return { error: result.error as FetchBaseQueryError };

            const productNestedProducts = result.data as NestedProduct[];

            return {
                data: productNestedProducts,
            };
        },
        providesTags: [{ type: 'product-nested-products', id: 'GET' }],
    });
